<section class="nw_service_th" *ngIf="!loader && businessListData.length > 0">
    <div class="service_se" style="display: flex;justify-content: space-between;">
        <div class="heading_sert">
            <h3> All members </h3>
        </div>
        <div class="create_btn_sd">
            <button mat-icon-button color="primary" (click)="addmember()"  >
                <mat-icon>add</mat-icon> 
            </button>
        </div>
    </div>
    <div class="chip_services_list">
        <mat-chip-listbox class="example-chip">
            <mat-chip (click)="selectBusiness(i)" *ngFor="let item of businessListData; let i =index" [ngClass]="{'Graceful-box-active': item.isSelected == 1}" >{{item.name}}</mat-chip>
       </mat-chip-listbox>
    </div>
    <div class="service_create_sd" style="
    margin-bottom: 20px;">
    <div class="row" >
        <div class="col-sm-10">
           <div class="serv_heading">
            <h3>Members of {{selectedBusiness.name}}</h3>
            <p>{{selectedBusiness.address_line}}</p>

        </div>
      </div>
      <div class="col-sm-2">
      </div>
    </div>
     <div class="search-bar-custom">
        <mat-form-field appearance="outline">
            <mat-label>Search</mat-label>
            <input [formControl]="searchString" (keyup)="searchServiceData()" matInput placeholder="Search for members">
            <button
          mat-button
          *ngIf="!searchString.value"
          matSuffix
          aria-label="Clear"
        >
          <mat-icon>search</mat-icon>
        </button>
        <button
        mat-button
        *ngIf="searchString.value"
        matSuffix
        aria-label="Clear"
        (click)="reset()"
      >
        <mat-icon>close</mat-icon>
      </button>
        </mat-form-field>
    </div>
    </div>


    
   <div class="row" *ngIf="!loader">
  <div class="col-sm-6 col-md-6 col-12" *ngFor="let data of membersData">
    <div class="plan-card" style="position: relative;" >
      <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options"
        style="position: absolute; right: 15px; top: 20px;">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu2="matMenu">
        <button mat-menu-item (click)="goviewdetails(data)">
          <mat-icon class="material-icons-outlined">info</mat-icon>
          <span>View details</span>
        </button>
        <button mat-menu-item (click)="createInvoiceForEnrolled(data)"
          *ngIf="(selectedValue == '1' || selectedValue == '2') && getInvoiceAccess(data.service_mode) ">
          <mat-icon class="material-icons-outlined">playlist_add</mat-icon>
          <span>Create membership invoice</span>
        </button>
        <!-- <button mat-menu-item (click)="openAllInvoices(data)">
          <mat-icon class="material-icons-outlined">receipt</mat-icon>
          <span>See all payments</span>
        </button> -->
        <button mat-menu-item (click)="openDueInvoices(data)">
          <mat-icon class="material-icons-outlined">pending_actions</mat-icon>
          <span>See due payments</span>
        </button>
      
        <!-- <button mat-menu-item (click)="openViewAttendance(data)" *ngIf="isEntityIndividual == '1'">
          <mat-icon class="material-icons-outlined">fact_check</mat-icon>
          <span>View attendance</span>
        </button> -->
        <button mat-menu-item (click)="openPaymentIntimation(data)" *ngIf="data.total_due > 0 && selectedBusiness.is_owner == 1">
          <mat-icon class="material-icons-outlined">share</mat-icon>
          <span>Send payment intimation</span>
        </button>
        <button mat-menu-item (click)="openmarkabsent(data)" *ngIf="isEntityIndividual == '1' && selectedValue != '0'">
          <mat-icon class="material-icons-outlined">disabled_by_default</mat-icon>
          <span>Mark absent</span>
        </button>
      
        <!-- <button mat-menu-item (click)="updateEnrolledMemberMembershipStatus(data,2)"
          *ngIf="selectedValue == '1' || selectedValue == '2'">
          <mat-icon class="material-icons-outlined">cancel</mat-icon>
          <span>Cancel membership</span>
        </button> -->
        <!-- <button mat-menu-item (click)="updateEnrolledMemberMembershipStatus(data,1)" *ngIf=" selectedValue == '0'">
          <mat-icon class="material-icons-outlined">check_circle</mat-icon>
          <span> Revive membership</span>
        </button> -->
        <!-- <button mat-menu-item (click)="deleteMember(data)">
          <mat-icon class="material-icons-outlined">delete</mat-icon>
          <span> Delete member</span>
        </button> -->
      </mat-menu>
      <div class="d-flex align-items-center">
       <div style="position: relative; flex-shrink: 0;">
          <div class="booking-initial" *ngIf="!data.image_thumb_url || data.image_thumb_url == 'null'">{{data.name.slice(0,1).toUpperCase()}}</div>
          <div *ngIf="data.image_thumb_url && data.image_thumb_url != 'null'" class=""
          style="position: relative; ">
          <img [src]="data.image_thumb_url != null 
            && data.image_thumb_url != 'null'
            && data.image_thumb_url != '' ? data.image_thumb_url : './assets/images/photo.png'" alt=""
            class="img-fluid rounded-circle booking-initial-img"
            style="width: 50px; height: 50px; object-fit: cover; object-position: center;" onerror="this.src='../../../../assets/images/user-avatar.svg'">
          </div>
          <div class="error_ioer" *ngIf="data.dispute_status == 2">
          <mat-icon>error</mat-icon>
          </div>
        </div>
        <div class="m-2 clskdf">
          <h2 class="plan-title"> {{ data.name }}</h2>
          <p class="plan-info">
            <span class="value">{{data.member_phone}}</span>,
            <span class="value">{{data.gender}}</span>
          
          </p>
        
        </div>
            </div>

            <div class="afasf">
              <p>  <span class="value">{{data.s_mode}},</span> <span class="label"> Due: </span> <span class="value">{{data.currency_symbol}}{{data.total_due.toFixed(2)}}</span></p>
              <!-- <p class="plan-info">
                <span class="label">Due: </span> <span class="value">{{data.currency_symbol}}{{data.total_due}}</span>
              </p> -->
              <p class="plan-cost my-2">
                <span class="label">Last payment: </span> <span class="value">{{data.last_payment_date | date}}</span>
              </p>
            </div>
      <!-- <p class="plan-cost">
        <span class="value">{{ data.bookingType }}</span>,
        <span class="label">Assigned to: </span><span class="value">{{ data.employee_name }} </span>
      </p> -->
    </div>
  </div>
</div>


    <!-- placeholder html start -->
    <div class="placeholder_started" *ngIf="!loader && membersData.length == 0">
      <div class="row">
        <div class="col-sm-4 col-md-4 col-12">
          <div class="dashboard_new">
           <mat-card>
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/members-dues.jpg">
               </div>
               <mat-card-title>No members to show.</mat-card-title>
               <mat-card-content>It seems like you haven't started on-boarding members to your business. Start adding here and manage professionally.
              </mat-card-content>
               <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="addmember()"> 
                     <mat-icon>add</mat-icon>
                     Add member
                  </button>
               </div>
               </div>
            </mat-card>
         </div>
        </div>

         <div class="col-sm-4 col-md-4 col-12">
               <div class="dashboard_new">
                <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/all-members.svg">
                 </div>
                 <mat-card-title>How to manage members?</mat-card-title>
                     <mat-card-content> Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> to manage membership in your business. You can check this video as well to get step by step help. 

                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openvideo()">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
       
        <div class="col-sm-4 col-md-4 col-12">
          <div class="dashboard_new">
            <mat-card>
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/helpsupport.png">
               </div>
               <mat-card-title>Facing any issue?</mat-card-title>
               <mat-card-content>For any difficulties in creating a new customer or if there's any issue with customer data, contact the support team.
              </mat-card-content>
               <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary"  (click)="opencontact()">
                     <mat-icon>support_agent</mat-icon>
                     Contact support 
                  </button>
               </div>
               </div>
            </mat-card>
         </div>
        </div>
      </div>
</div> 
<!-- placeholder html end -->

</section>
<section class="nw_service_th" *ngIf="!loader && businessListData.length == 0">
    <div class="">
        <div class="heading_sert">
            <h3>All members</h3>
        </div>
    </div>

       <!-- Placeholder design html start -->
       <div class="placeholder_started__business">
        <div class="row">
          <div class="col-sm-4 col-md-4 col-12" *ngIf="!isEmployeeAndHasBusinessButDoesNotHaveAccess">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/business-create.png" style="width: 110px;">
                 </div>
                 <mat-card-title>No business added yet.</mat-card-title>
                 <mat-card-content>To add your members you need to create a business first. Members will be added under that business.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary" (click)="selectcountry()">
                        <mat-icon>add</mat-icon> 
                        Create a business
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
       <div class="col-sm-4 col-md-4 col-12" *ngIf="isEmployeeAndHasBusinessButDoesNotHaveAccess">
                <div class="dashboard_new" >
                  <mat-card appearance="outlined" style="">
                      <div class="upload_sectio">
                     <div class="icm_img">
                        <img src="./assets/images/business-create.png" style="width: 110px;">
                     </div>
                     <mat-card-title>Access denied.</mat-card-title>
                     <mat-card-content> Business owner with valid premium business subscription or an active employee with permission can access this section. Check current plans. Recharge pack if expired.
                    </mat-card-content>
                     
                     </div>
                  </mat-card>
               </div>
              </div>
              <div class="col-sm-4 col-md-4 col-12">
               <div class="dashboard_new">
                <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/all-members.svg">
                 </div>
                 <mat-card-title>How to manage members?</mat-card-title>
                        <mat-card-content> Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> to manage membership in your business. You can check this video as well to get step by step help. 

                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openvideo()">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4 col-md-4 col-12">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Having any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in adding members or if there's any issue while adding members, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
    
      </div>
      <!-- Placeholder design html start -->
    
      
</section>